import React, { useEffect,useCallback } from 'react';
import { useDispatch } from "react-redux";
import Axios from '../../../axios/Axios';
import { showSnackbar } from "../../redux/features/appSlice";
import { IconButton, Badge, Typography, Box, Tooltip, Menu } from "@mui/material";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { Notifications } from '@mui/icons-material';
import axios from 'axios';

export const NotificationModalReuse = ({ getNotificationUrl, clearNotificationUrl }) => {

    const dispatch = useDispatch();
    const [notifyOpen, setNotifyOpen] = React.useState(false);
    const [notificationList, setNotificationList] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // useEffect(() => {
    //     (async () => {
    //         try{
    //             const options = {
    //                 method: "get",
    //                 url: getNotificationUrl,
    //                 auth: true,
    //                 data: null,
    //             };

    //             const {data} = await Axios(
    //                 options.method,
    //                 options.url,
    //                 options.auth,
    //                 options.data
    //             );

    //             setNotificationList(data)
    //         }catch(err){
    //             dispatch(
    //                 showSnackbar({
    //                     message: "Couldn't able to retrieve notifications",
    //                     severity: "error",
    //                 })
    //             );
    //         }
    //     })();
    // },[notifyOpen, dispatch, getNotificationUrl])


    const clearNotification = async () => {
        try {
            const options = {
                method: "PUT",
                url: clearNotificationUrl,
                auth: true,
                data: null,
            };

            const response = await Axios(
                options.method,
                options.url,
                options.auth,
                options.data
            );
            // console.log(response);
            if (response.status === 200) {
                setNotifyOpen(false)
                fetchNotificationList()
            }
        } catch (err) {
            dispatch(
                showSnackbar({
                    message: "Unable to clear notifications",
                    severity: "error",
                })
            );
        }
    }

    // const fetchNotificationList = async () => {
    //     const controller = axios.CancelToken.source();
    //     try {
    //         const options = {
    //             method: "get",
    //             url: getNotificationUrl,
    //             auth: true,
    //             data: null,
    //             token:{cancelToken: controller.token}
    //         };

    //         const { data } = await Axios(
    //             options.method,
    //             options.url,
    //             options.auth,
    //             options.data,
    //             options.token,
    //             );

    //         setNotificationList(data.reverse())
    //     } catch (err) {
    //         if (!axios.isCancel(err)) {
    //             dispatch(
    //                 showSnackbar({
    //                     message: "Couldn't able to retrieve notifications",
    //                     severity: "error",
    //                 })
    //             );
    //         }

    //     }
    //     return () => {
    //         controller.cancel();
    //     }
    // }


const fetchNotificationList = useCallback(async () => {
  const controller = axios.CancelToken.source();

  try {
    const options = {
      method: "get",
      url: getNotificationUrl,
      auth: true,
      data: null,
      token: { cancelToken: controller.token },
    };

    const { data } = await Axios(
      options.method,
      options.url,
      options.auth,
      options.data,
      options.token
    );

    setNotificationList(data.reverse());
  } catch (err) {
    if (!axios.isCancel(err)) {
      dispatch(
        showSnackbar({
          message: "Couldn't able to retrieve notifications",
          severity: "error",
        })
      );
    }
  }

  return () => {
    controller.cancel();
  };
}, [getNotificationUrl, dispatch]);


    useEffect(() => {
        fetchNotificationList();
    }, [notifyOpen, getNotificationUrl,fetchNotificationList]);

    return (
        <>
            <IconButton
                sx={{ color: "white", mr: "16px" }}
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Badge color="error" badgeContent={notificationList.length} max={10}>
                    <Notifications fontSize="medium" />
                </Badge>
            </IconButton>
            <Menu
                sx={{
                    top: 60,
                    maxHeight: 500,
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ width: 350, p: "5px" }}>
                    <Box sx={{ borderBottom: "2px solid #E2E2E3", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography variant="h6">
                            {notificationList.length > 0 ? "You got some notifications..." : "No new notifications"}
                        </Typography>
                        <Tooltip title="Clear">
                            <IconButton onClick={clearNotification}>
                                <ClearAllIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box>
                        {notificationList.length > 0 && notificationList.reverse().map((notification, index) => {
                            return (
                                <div key={index} style={{ borderBottom: "1px solid #E2E2E3", padding: "5px" }}>
                                    <Typography variant="body1">
                                        {notification.notif_title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {notification.notif_description}
                                    </Typography>
                                </div>
                            )
                        })}
                    </Box>
                </Box>
            </Menu>
        </>
    )
}
